<template>
  <!-- 栅格布局方式
       @author: 王汝鹏
       @date: 2019-9-13
   -->
  <div class="setting-item">
    <el-form-item label="水平排列方式"> 
      <el-select class="setting-grid-justify" v-model="justify">
        <el-option value="start" label="左对齐"></el-option>
        <el-option value="end" label="右对齐"></el-option>
        <el-option value="center" label="居中"></el-option>
        <el-option value="space-around" label="两侧间隔相等"></el-option>
        <el-option value="space-between" label="两端对齐"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 基础属性-栅格水平排列方式
     *  @description 将 justify 字段映射到当前 justify 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-10
     */
    ...mapComputed({
      justify: { 
        parent: i => i.baseOption,
        attr: "justify" 
      }
    }),
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/base_setting/SettingGridJustify.vue